module.exports = __webpack_public_path__ + "img/pr1.1fe902e7.jpg";